import React from 'react';
import InputGenerator from "./inputGenerator";
import ModuleConfiguration from "./model";
import { Form } from "semantic-ui-react";
import { fetchAPI } from "api";
import { extractParameters } from "./urls";
import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3';
import useTopWindowData from "./ipc";

// decoy function used when auth is empty in edit mode
async function mockSubscribe(data) {
    await new Promise(resolve => setTimeout(resolve, 2000)); // simulate a 2s delay
    return true;
}

export default function Module() {

    const [recaptchaToken, setRecaptchaToken] = React.useState(null);

    const queryString = window.location.search;
    const parameters = extractParameters(queryString);

    // Get the parent data from the root page
    const { page, referrer } = useTopWindowData();

    // Generate a configuration module from the URL
    const configuration = React.useMemo(() => {
        return new ModuleConfiguration(parameters);
    }, [parameters]);

    const recaptcha = React.useRef();

    React.useEffect(() => {
        if (configuration.recaptcha) {
            loadReCaptcha(window.weezConfig.recaptcha.site_key);
        }
    }, [configuration.recaptcha]);

    // Get the auth token from the URL
    const { path, auth } = parameters;

    // Generate the subscribe function. If auth is defined, send the request to the API
    // else generate a mock function
    const subscribe = React.useMemo(() => {
        if (!auth) {
            return mockSubscribe;
        }

        const headers = configuration.recaptcha ?  {
            'x-recaptcha': recaptchaToken,
        } : {};

        const action = {};

        if(page) {
            action["page"] = page;
        }

        if(referrer) {
            action["referrer"] = referrer;
        }

        return async (data) => {
            if (configuration.recaptcha) {
                recaptcha.current.execute();
            }
            const { ok } = await fetchAPI(path, auth, {
                method: 'POST',
                data: {
                    contact_data: data,
                    action_data: action,
                },
                headers
            });
            return ok;
        };
    }, [auth, page, referrer, recaptchaToken, configuration.recaptcha, path]);

    return (
        <div className={ `App${configuration.recaptcha ? ' container-recaptcha' : ''}` }>
            <Form>
                <div className="content email-input-content" style={ {
                    width: '100%',
                    maxWidth: configuration.wrapperWidth,
                } }>
                    <div className={ `email-input-content${configuration.separated ? " separated" : ""}` }>
                        <InputGenerator
                            configuration={ configuration }
                            onSubmit={ subscribe }
                        />
                    </div>
                    { configuration.recaptcha &&
                        <ReCaptcha
                            ref={ recaptcha }
                            sitekey={ window.weezConfig.recaptcha.site_key }
                            action='submit'
                            verifyCallback={ setRecaptchaToken }
                        />
                    }
                </div>
            </Form>
            <style dangerouslySetInnerHTML={ {__html: `
                .content .ui.selection.dropdown .menu {
                    border-bottom-left-radius: ${configuration.btnDefault.borderRadius};
                    border-bottom-right-radius: ${configuration.btnDefault.borderRadius};
                }
                .content .ui.upward.selection.dropdown.visible {
                    border-bottom-left-radius: ${configuration.btnDefault.borderRadius} !important;
                    border-bottom-right-radius: ${configuration.btnDefault.borderRadius} !important;
                }
                .content .ui.selection.upward.dropdown .menu {
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                    border-top-left-radius: ${configuration.btnDefault.borderRadius};
                    border-top-right-radius: ${configuration.btnDefault.borderRadius};
                }
                .content .ui.checkbox input:checked~label:after {
                    color: ${configuration.btnDefault.backgroundColor};
                }
            `} } />
        </div>
    );
}
